<template>
  <div>
    <b-form-group label="Senha:" class="d-block">
      <b-input-group>
        <b-form-input
          v-model="modelValue.password"
          :state="validateState('password')"
          :type="viewPassword ? 'text' : 'password'"
          placeholder="Senha"
        />
        <b-input-group-append>
          <b-input-group-text class="p-0">
            <button
              class="border-0 bg-transparent mr-2 outline-0"
              type="button"
              @click="viewPassword = !viewPassword"
            >
              <font-awesome-icon
                :icon="viewPassword ? 'eye-slash' : 'eye'"
                class="text-exitos"
              />
            </button>
          </b-input-group-text>
        </b-input-group-append>
      </b-input-group>
      <b-form-invalid-feedback :state="validateState('password')">
        <span v-if="v$.password.required.$invalid">
          Senha é um campo obrigatório.
        </span>
        <span v-else-if="v$.password.minLength.$invalid">
          A senha precisa ter no mínimo 6 caracteres.
        </span>
      </b-form-invalid-feedback>
      <b-form-text>
        Após salvar as informações, esse campo será apagado.
      </b-form-text>
    </b-form-group>
    <b-form-group label="Confirmar Senha:" class="d-block mb-0">
      <b-input-group>
        <b-form-input
          v-model="modelValue.password_confirmation"
          :state="validateState('password_confirmation')"
          :type="viewPasswordConfirmation ? 'text' : 'password'"
          placeholder="Confirmar senha"
        />
        <b-input-group-append>
          <b-input-group-text class="p-0">
            <button
              class="border-0 bg-transparent mr-2 outline-0"
              type="button"
              @click="viewPasswordConfirmation = !viewPasswordConfirmation"
            >
              <font-awesome-icon
                :icon="viewPasswordConfirmation ? 'eye-slash' : 'eye'"
                class="text-exitos"
              />
            </button>
          </b-input-group-text>
        </b-input-group-append>
      </b-input-group>
      <b-form-invalid-feedback :state="validateState('password_confirmation')">
        <span v-if="v$.password_confirmation.required.$invalid">
          Confirme a senha informada.
        </span>
        <span v-else-if="v$.password_confirmation.sameAsPassword.$invalid">
          As senhas não coincidem.
        </span>
      </b-form-invalid-feedback>
    </b-form-group>
  </div>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import { useVModel } from "@vueuse/core";
import { computed, defineComponent, ref } from "vue";
import { minLength, requiredIf, sameAs } from "@vuelidate/validators";

export default defineComponent({
  props: {
    value: {
      type: Object,
      default: () => ({
        password: "",
        password_confirmation: "",
      }),
    },
  },
  emits: ["input"],
  setup(props, { emit }) {
    const modelValue = useVModel(props, "value", emit);

    const viewPassword = ref(false);
    const viewPasswordConfirmation = ref(false);
    const password = computed(() => modelValue.value.password);

    const rules = computed(() => ({
      password: {
        required: requiredIf(!modelValue.value.id),
        minLength: minLength(6),
      },
      password_confirmation: {
        required: requiredIf(Boolean(password.value)),
        sameAsPassword: sameAs(password),
      },
    }));

    const v$ = useVuelidate(rules, modelValue);

    function validateState(name) {
      const $field = Reflect.get(v$.value, name) || {};
      return $field.$dirty ? !$field.$error : null;
    }

    function validate() {
      v$.value.$touch();
      return !v$.value.$invalid;
    }

    return {
      v$,
      modelValue,
      viewPassword,
      viewPasswordConfirmation,
      validate,
      validateState,
    };
  },
});
</script>
